import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import {
  KeyboardArrowLeft,
} from '@material-ui/icons';
import React, {
  Component,
} from 'react';
import classes from './PageTitleWithBackButton.module.scss';

interface IProps {
  pageTitle: string;
  history?: any;
}

class PageTitleWithBackButton extends Component<IProps> {
  render() {
    return (
      <div className={classes.container}>
        <IconButton
          className={classes.backButton}
          onClick={() => this.props.history.goBack()}
          aria-label="Back"
        >
          <KeyboardArrowLeft />
        </IconButton>
        <Typography className={classes.title} variant="h6" gutterBottom>
          {this.props.pageTitle}
        </Typography>
      </div>
    );
  }
}

export default PageTitleWithBackButton;
